import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/base/bankchangeinfo/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/base/bankchangeinfo/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/base/bankchangeinfo/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/base/bankchangeinfo/submit', params, options);

export const update = (params, options) =>
  request.post('/api/base/bankchangeinfo/submit', params, options);
